import React from 'react';
import PropTypes from 'prop-types';

import CustomTypes from '../../types';

import { ButtonStyled, LinkStyled, AnchorStyled } from './Button.styled';

const SpinnerPath = () => (
  <svg id="path" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.72 130.72"><path d="M4.57 66.57c0-33.69 27.31-61 61-61s61 27.31 61 61" fill="none" stroke="#000" strokeWidth="10" strokeLinecap="round" strokeMiterlimit="1" strokeDasharray="117300,105" /></svg>
);

const Button = ({
  label,
  modifiers,
  to,
  href,
  disabled,
  loading,
  icon,
  ...props
}) => {
  const modifiersArray = Array.isArray(modifiers) ? modifiers : [modifiers];
  if (disabled) {
    modifiersArray.push('disabled');
  }
  if (loading) {
    modifiersArray.push('loading');
  }
  let buttonType = (
    <ButtonStyled modifiers={modifiersArray} {...props}>
      {modifiersArray.includes('loading') ? <SpinnerPath /> : null}
      {icon}
      <span>{label}</span>
    </ButtonStyled>
  );
  if (href) {
    buttonType = (
      <AnchorStyled href={href} {...props} modifiers={modifiersArray}>
        {icon}
        <span>{label}</span>
      </AnchorStyled>
    );
  } else if (to) {
    buttonType = (
      <LinkStyled to={to} modifiers={modifiersArray}>
        {icon}
        <span>
          {label}
        </span>
      </LinkStyled>
    );
  }
  return buttonType;
};

Button.propTypes = {
  label: PropTypes.string,
  modifiers: CustomTypes.oneOrMore([
    '',
    'wShadow',
    'primary',
    'loading',
    'dark',
    'darkest',
    'secondary',
    'disabled',
    'outline',
    'textButton',
    'woBorder',
  ]),
  to: PropTypes.string,
  href: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  icon: PropTypes.node,
};

Button.defaultProps = {
  label: '',
  modifiers: '',
  to: '',
  href: '',
  disabled: false,
  loading: false,
};

export default Button;
